import { render, staticRenderFns } from "./PastQueue.vue?vue&type=template&id=0ea139a1&"
import script from "./PastQueue.vue?vue&type=script&lang=js&"
export * from "./PastQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports